// extracted by mini-css-extract-plugin
export default {"cardContainer":"InstructionsCard_cardContainer__-c9A0","instructionsImage":"InstructionsCard_instructionsImage__6hTz7"};